import {$api} from "../AxiosInstance";

export class PaymentService {
    static getAll(payload) {
        return $api.post("/api/admin/payment/all", payload);
    }
}
